import Component from '@glimmer/component';
import { action } from '@ember/object';
import PrecisionStudioMenu from '@ebiz/aditools-precisionstudio-menu';
import '@ebiz/aditools-precisionstudio-menu/lib/precisionstudio-menu.css';
import AditoolsRenderer from '../modifiers/aditools-renderer.ts';

export interface AditoolsStudioDropdownSignature {
  Element: HTMLDivElement;
  Args: {
    locale?: string;
    toolUrls?: { [K: string]: string };
  };
}

export default class AditoolsStudioDropdown extends Component<AditoolsStudioDropdownSignature> {
  renderer = AditoolsRenderer;
  precisionStudioMenu?: PrecisionStudioMenu;

  // Optional parameters with defaults applied
  get _toolUrls() {
    return this.args.toolUrls ?? {};
  }

  get _locale() {
    return this.args.locale ?? 'en';
  }

  @action
  insertedMenu(element: Element) {
    this.precisionStudioMenu = new PrecisionStudioMenu({
      locale: this._locale,
      toolurls: this._toolUrls,
    });
    this.precisionStudioMenu.attach(element);
  }

  @action
  destroyingMenu(/*element: Element*/) {
    if (this.precisionStudioMenu) {
      this.precisionStudioMenu.detach();
      this.precisionStudioMenu = undefined;
    }
  }
}
